import { FileType } from "../types";

export function getFileType(file: File): FileType {
    const extension = file.name.split('.').pop()?.toLowerCase();
    switch (extension) {
        case 'docx':
            return 'docx';
        case 'pptx':
            return 'pptx';
        case 'pdf':
            return 'pdf';
        case 'txt':
            return 'txt';
        case 'md':
            return 'markdown';
        default:
            return 'unknown';
    }
}
